// Filename: uicanvasstageseqaction.js
// Timestamp: 2017.11.19-13:42:37 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>

import gnnodexui from '@bumblehead/gani/src/gnnodexui.js'

const setstagecanvaselemcursor = (stagecfg, cursorstyle) => {
  const canvaselem = stagecfg.glcanvaselem

  if (canvaselem)
    canvaselem.style.cursor = cursorstyle
}

export default Object.assign({}, gnnodexui, {
  type: 'uicanvasstageseqaction',
  setstagecanvaselemcursor
})
